/**
 * Lexa navigation warm — complements instant.page + <script type="speculationrules">.
 * - Browsers with Speculation Rules: no-op (native handles prerender/prefetch hints).
 * - Else if <link rel=prefetch> is supported: inject prefetch for same-origin hints from #lexa-prefetch-hints.
 * - Else: low-priority fetch() as a best-effort warm (e.g. some older iOS where document prefetch is weak).
 */
(function () {
  'use strict';

  function supportsSpeculationRules() {
    return (
      typeof HTMLScriptElement !== 'undefined' &&
      HTMLScriptElement.supports &&
      HTMLScriptElement.supports('speculationrules')
    );
  }

  function supportsLinkPrefetch() {
    try {
      var link = document.createElement('link');
      return !!(link.relList && link.relList.supports && link.relList.supports('prefetch'));
    } catch (e) {
      return false;
    }
  }

  function scheduleIdle(fn) {
    var ric = window.requestIdleCallback;
    if (typeof ric === 'function') {
      ric(
        function () {
          fn();
        },
        { timeout: 4500 }
      );
    } else {
      setTimeout(fn, 1800);
    }
  }

  function run() {
    var el = document.getElementById('lexa-prefetch-hints');
    if (!el) return;

    var urls;
    try {
      urls = JSON.parse(el.textContent || '[]');
    } catch (e) {
      return;
    }
    if (!urls || !urls.length) return;

    if (supportsSpeculationRules()) {
      return;
    }

    if (supportsLinkPrefetch()) {
      urls.forEach(function (href) {
        if (!href || typeof href !== 'string') return;
        var link = document.createElement('link');
        link.rel = 'prefetch';
        link.href = href;
        if ('fetchPriority' in link) link.fetchPriority = 'low';
        document.head.appendChild(link);
      });
      return;
    }

    if (typeof fetch !== 'function') return;

    urls.forEach(function (href) {
      if (!href || typeof href !== 'string') return;
      try {
        var u = new URL(href, window.location.href);
        if (u.origin !== window.location.origin) return;
      } catch (e) {
        return;
      }
      var opts = {
        mode: 'same-origin',
        credentials: 'same-origin',
        cache: 'default'
      };
      try {
        fetch(href, Object.assign(opts, { priority: 'low' })).catch(function () {});
      } catch (e) {
        fetch(href, opts).catch(function () {});
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scheduleIdle(run);
    });
  } else {
    scheduleIdle(run);
  }
})();
